import React, {Component} from 'react';
import {Platform, View, TouchableOpacity, Image, Clipboard, I18nManager} from 'react-native';
import HMTextView from './HMTextView';
import Colors from '../tools/Colors';
import {moderateScale} from '../tools/Scaling';

import {connect} from 'react-redux';

import * as NavigationService from '../redux/NavigationService';
import store from '../redux/store';
import HMIcon from './HMIcon';
import {serviceActionSetState} from '../screens/137/splash/action/ActionSplashGetAllData';
import PathFile from '../assets/PathFile';
import {typeExport} from '../redux/store/type';
import {GoLink, GoLink_AI} from '../tools/Tools1';
import _G_ from '../tools/constant/_G_';
import * as Linking from 'react-native';

let container = null;


class HMActionBar extends Component {
    constructor(props) {
        super(props);

        container = this;
        let widthOriginal = Platform.OS === 'web' ? 1 : typeExport._WIDTH;
        if (Platform.OS === 'web') {
            let viewportHeight = document.body.clientHeight;
            widthOriginal = document.body.clientWidth;
        }
        this.state = {
            widthOriginal: widthOriginal,
        };
    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };

    hideMenu = () => {
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    componentDidMount() {


        if (Platform.OS === 'web') {
            window.addEventListener('resize', function (event) {
                container.setState({
                        widthOriginal: document.body.clientWidth,
                    },
                );
            });
        }
    }

    render() {
        var checkMenuCloud = this.state.widthOriginal > 1400 && (typeExport._NameApp === 'Cloud' || typeExport._NameApp === 'CloudTest');

        const {RigjhtView,menuWebCloud, LeftView, styleText, onClickProfile, exit, profile, menu, text, ViewCenter, logo, more_menu, back, onBackPress, headerVisibility, statusBarTransparent, style, transparent, drawer, props, funcExit} = this.props;
        let checkLogin = false;


        let store_data = this.props.DataSplashScreen;

        let checkLoginCloud = (store_data.TypeLogin == 2);
        let DataSplashScreenSaina = checkLoginCloud ? (store_data.resultsShahrdar ? store_data.resultsShahrdar.result : null) : (store_data.resultsSaina ? store_data.resultsSaina.result : null);

        return (
            <View>{
                headerVisibility ?
                    <View>
                        {/*                <StatusBar translucent={statusBarTransparent} barStyle="light-content"
                           backgroundColor={statusBarTransparent ? "rgba(256,256,256,0)" : Colors.backgroundColorDarker}/>*/}
                        {Platform.OS === 'ios' ?
                            <View style={{
                                backgroundColor: Platform.OS === 'ios' ? Colors.colorPrimaryDark : Colors.transparent,
                                width: '100%',
                                //height:Constants.HeightStatusBar,
                                height: moderateScale(20),

                            }}/> : null}

                        <View
                            style={[{
                                // flexDirection: Rtl ? 'row-reverse' : 'row',
                                flexDirection: 'row',

                                //   justifyContent: Rtl ? 'flex-start' : 'flex-end',
                                height: Platform.OS === 'ios' ? moderateScale(48) : moderateScale(48),
                                alignItems: 'center',
                                backgroundColor: Colors.colorPrimary,
                            }, style]}>


                            <View
                                style={[{
                                    // flexDirection: Rtl ? 'row-reverse' : 'row',
                                    flexDirection: 'row',
                                    //alignSelf:Rtl   ?  "flex-start" : "flex-end",
                                    // width:  Constants.WIDTH/2-moderateScale(26),
                                    // height: moderateScale(48)
                                    //backgroundColor: '#ee050d'

                                    //marginHorizontal: moderateScale(6),
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }, (profile || back) && (!menu || checkLogin) ? {
                                    width: moderateScale(48),
                                    height: moderateScale(48),
                                } : {}]}>
                                {(menu && !checkLogin) || (menu === 'home' && Platform.OS !== 'web') ? <TouchableOpacity
                                        style={{

                                            //    marginHorizontal: moderateScale(10),
                                            width: moderateScale(48),
                                            height: moderateScale(48),

                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}

                                        onPress={

                                            //  onBackPress
                                            () => {
                                                if (menu === 'home') {
                                                    //Linking.getInitialURL().then((url) => {

                                                      //  console.log(url);
                                                   // alert(window.location.origin)
                                                        GoLink(window.location.origin+"/start.html","self");
                                                        //console.log()

                                                    // });

                                                }
                                                else {
                                                    //alert(this.props.token_fb)
                                                    if (Platform.OS === 'web')
                                                    // this.props.navigation.toggleDrawer()
                                                    {
                                                        if (Clipboard) {
                                                            Clipboard.setString(this.props.token_fb);
                                                        }
                                                    }
                                                    props.navigation.toggleDrawer();
                                                }

                                            }
                                        }>
                                        <HMIcon name={menu === 'home'?"home":'ios-menu'}
                                                style={{fontSize: moderateScale(26), color: Colors.light}}/>
                                        {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                        {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                    </TouchableOpacity>
                                    :
                                    null
                                }
                                {RigjhtView}

                            </View>

                            <View
                                style={{
                                    flexDirection: 'row',
                                    flex: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center',

                                }}>
                                {
                                    logo ?
                                        <Image

                                            //resizeMode={"stretch"}
                                            style={{
                                                width: moderateScale(50),
                                                height: moderateScale(27),

                                                //position: 'absolute',
                                                //borderRadius: 50),
                                                //     backgroundColor: Colors.white


                                            }}
                                            // source={require('../../../assets/img/logo.png')}
                                            source={PathFile.image.name_satia}
                                            //source={{uri: "https://painrelief-blog.org/wp-content/uploads/2019/07/5d2233166143e.jpg"}}
                                        />
                                        :

                                        (ViewCenter ?
                                                ViewCenter()
                                                :
                                                <HMTextView
                                                    numberOfLines={1}
                                                    text={text}
                                                    type="bold"
                                                    style={{
                                                        alignSelf: 'center',
                                                        color: Colors.light,
                                                        fontSize: moderateScale(16),
                                                    }}
                                                    // onPressLink={() => {
                                                    //     NavigationService.navigate("ListCityScreen")
                                                    // }}
                                                />
                                        )

                                }

                            </View>


                            <View
                                style={[{

                                    flexDirection: 'row',
                                    //    marginHorizontal: moderateScale(10),
                                    // width:Constants.WIDTH/2-moderateScale(26),
                                    // width:0,
                                    // height: moderateScale(48),

                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    paddingEnd: moderateScale(LeftView ? 16 : 0),

                                }, !(back && profile) && (menu) ? {
                                    width: moderateScale(48),
                                    height: moderateScale(48),
                                } : {}]}>
                                {LeftView}

                                {back ? <TouchableOpacity
                                    style={{
                                        //  backgroundColor: "#ee1c27",

                                        //    marginHorizontal: moderateScale(10),
                                        width: moderateScale(LeftView ? 24 : 48),
                                        height: moderateScale(48),

                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}

                                    onPress={
                                        () => {
                                            let search = props.route.key.search && props.route.key.search('LoginEnterPhoneScreen');

                                            if (search >= 0) {
                                                NavigationService.navigate('HomeStackScreen');


                                            }
                                            else {
                                                /*  Platform.OS === "web" ?
                                                      window.history.back()
                                                    //  this.props.history.goBack()
                                                      :*/
                                                props.navigation.pop();

                                            }
                                            //NavigationService.Pop()
                                            //  drawer ? NavigationService.navigate('HomeStackScreen') : props.navigation.pop()
                                            // props.navigation.pop()
                                            // drawer ? props.navigation.popToTop() : props.navigation.pop()
                                        }

                                    }>
                                    <View style={{
                                        //  flexDirection:Rtl ? 'row-reverse': 'row',
                                        flexDirection: 'row',
                                        alignItems: 'flex-end',
                                        //marginHorizontal: moderateScale(4)
                                    }}>
                                        <HMIcon name={
                                            //Rtl ? "ios-arrow-back":'ios-arrow-forward'
                                            _G_ ? 'ios-arrow-back' : 'ios-arrow-forward'
                                            // 'ios-arrow-back'

                                        }
                                                style={{fontSize: moderateScale(24), color: Colors.light}}/>
                                        {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                        {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                    </View>
                                </TouchableOpacity> : null}

                                {exit ? <TouchableOpacity
                                    style={{

                                        //    marginHorizontal: moderateScale(10),
                                        width: moderateScale(LeftView ? 24 : 48),
                                        height: moderateScale(48),

                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}

                                    onPress={
                                        () => {
                                            funcExit ? funcExit() : null;

                                            // NavigationService.resetTo("SplashSatiaScreen")
                                        }
                                        //  onBackPress
                                        // () => {
                                        //     Tools.changeAppLang('en');
                                        // }
                                    }>
                                    <View style={{
                                        //  flexDirection:Rtl ? 'row-reverse': 'row',
                                        flexDirection: 'row',
                                        alignItems: 'flex-end',
                                        //marginHorizontal: moderateScale(4)
                                    }}>
                                        <HMIcon name={'md-log-in'}
                                                style={{fontSize: moderateScale(26), color: Colors.light}}/>
                                        {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                        {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                    </View>
                                </TouchableOpacity> : null}

                                {profile && !checkLogin ? <TouchableOpacity
                                    style={{

                                        //    marginHorizontal: moderateScale(10),
                                        width: moderateScale(LeftView ? 24 : 48),
                                        height: moderateScale(48),

                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}

                                    onPress={
                                        () => {
                                            //   NavigationService.navigateParams('ProfileScreen')
                                            if (store.getState().reducerSplashGetAllData.token != null) {
                                                NavigationService.navigateParams('ProfileScreen');

                                            } else {
                                                store.dispatch(serviceActionSetState({type: 'ProfileScreen'}));

                                                // alert("hjk")
                                                if (onClickProfile) {
                                                    NavigationService.navigateParams('LoginEnterPhoneSatiaScreen');
                                                }// onClickProfile();
                                                else {
                                                    NavigationService.navigateParams('LoginStackScreen');
                                                }

                                            }
                                            // props.navigation.pop()
                                        }
                                    }>
                                    <View style={{
                                        //  flexDirection:Rtl ? 'row-reverse': 'row',
                                        flexDirection: 'row',
                                        alignItems: 'flex-end',
                                        //marginHorizontal: moderateScale(4)
                                    }}>
                                        <HMIcon name={'md-person'}
                                                style={{fontSize: moderateScale(25), color: Colors.light}}/>

                                    </View>
                                </TouchableOpacity> : null}


                            </View>


                            {(checkMenuCloud) &&
                            <View style={{flexDirection: 'row', position: 'absolute', right: moderateScale(50)}}>
                                <HMTextView type={'bold'}

                                            style={{
                                                fontSize: moderateScale(13),
                                                color: Colors.white,
                                                marginEnd: moderateScale(20),
                                                // marginTop: moderateScale(10)
                                            }}
                                            text={'خانه'}
                                            onPressLink={() => {
                                                NavigationService.PopToPop();
                                            }}
                                    //   text={"98/03/21"}
                                />
                                <HMTextView type={'bold'}

                                            style={{
                                                fontSize: moderateScale(13),
                                                color: Colors.white,
                                                marginEnd: moderateScale(20),
                                                // marginTop: moderateScale(10)
                                            }}
                                            text={'پورتال استانداری'}
                                            onPressLink={() => {
                                                GoLink(DataSplashScreenSaina?.info?.portal);
                                            }}
                                    //   text={"98/03/21"}
                                />
                                <HMTextView type={'bold'}

                                            style={{
                                                fontSize: moderateScale(13),
                                                color: Colors.white,
                                                marginEnd: moderateScale(20),
                                                // marginTop: moderateScale(10)
                                            }}
                                            text={'دانلود اپلیکیشن'}
                                            onPressLink={() => {
                                                GoLink_AI(DataSplashScreenSaina?.info.ios.link, DataSplashScreenSaina?.info.android.link);
                                            }}
                                    //   text={"98/03/21"}
                                />
                                <HMTextView type={'bold'}

                                            style={{
                                                fontSize: moderateScale(13),
                                                color: Colors.white,
                                                marginEnd: moderateScale(20),
                                                // marginTop: moderateScale(10)
                                            }}
                                            text={'درباره نرم افزار'}
                                            onPressLink={() => {
                                                NavigationService.navigateParams('AboutUsScreen');

                                            }}
                                    //   text={"98/03/21"}
                                />
                            </View>}
                        </View>
                    </View>
                    :
                    null
            }

            </View>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        CartList: state.reducerSplashGetAllData.CartList,
        PriceAll: state.reducerSplashGetAllData.PriceAll,
        Rtl: state.reducerSplashGetAllData.Rtl,
        DataSplashScreen: state.reducerSplashGetAllData,
    };
};
const mapDispatchToProps = dispatch => {
    return {};
};
HMActionBar = connect(mapStateToProps, mapDispatchToProps)(HMActionBar);
// = withRouter(connect(mapStateToProps, mapDispatchToProps)(HMActionBar));
export default (props) => {

    //let history = useHistory();
    // console.log("history1", history);

    return (
        <HMActionBar
            //history={history}
            {...props}  />
    );
}
